// extracted by mini-css-extract-plugin
export default {"tooltip":"vK-z","arrow":"wK-z"};